module.exports = {
	"dashboard": "หน้าหลัก",
	"calendar": "ปฏิทิน",
	"submit": "ส่ง",
	"create": "สร้าง",
	"cancel": "ยกเลิก",
	"delete": "ลบ",
	"deleteConfirm": "คุณมั่นใจที่จะลบ?",
	"edit": "แก้ไข",
	"confirm": "ยืนยัน",
	"view": "รายการ",
	"pickdate": "เลือกวันที่",
	"save": "บันทึก",
	"new": "เพิ่ม",
	"continueCreate": "บันทึกและเพิ่มต่อ",
	"pleaseSelect": "กรุณาเลือก",
	"changeStatus": "เปลี่ยนสถานะ",
	"wordboard": "Wordboard"
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/th/base.json
// module id = 835
// module chunks = 1